module.exports = __webpack_public_path__ + "static/percent-of-profit-static-433177f700007c6c81f7bad4849af26b.png";